import { Button } from "@devhop/ui";
import { HelpCircleIcon, PlusIcon } from "lucide-react";

type OptionsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour: () => void;
};

export function OptionsToolbar({
  canManage,
  onCreate,
  onStartTour,
}: OptionsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            Product Options{" "}
            <Button
              variant="ghost"
              size="icon"
              onClick={onStartTour}
              className="ml-2 size-6"
              title="ເລີ່ມທົດລອງການນຳທາງ"
            >
              <HelpCircleIcon className="h-4 w-4" />
            </Button>
          </h2>
          <p className="text-muted-foreground">
            ຈັດການ option ສິນຄ້າ (Color, Size ແລະຄ່າຕ່າງໆ).
          </p>
        </div>
        <div className="flex items-center gap-2">
          {canManage && (
            <Button onClick={onCreate} data-tourid="catalog-options-create-btn">
              <PlusIcon className="h-4 w-4" />
              ສ້າງ Option
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
